/**
 * Tenant feature display names from login/ping (`featureDisplayByKey`).
 * Features Manager is the source of truth; menubar labels use the same names from the server merge.
 */
import { getCatalogKeyForRoute as resolveCatalogKeyForRoute } from '@/utils/navigationCatalog';

export function getFeatureDisplayByKey(store) {
  const fromGetter = store?.getters?.getFeatureDisplayByKey;
  if (fromGetter && typeof fromGetter === 'object') return fromGetter;
  return store?.state?.auth?.featureDisplayByKey ?? {};
}

export function normalizeFeatureLocale(locale = 'en') {
  return String(locale).toLowerCase().startsWith('de') ? 'de' : 'en';
}

export function getFeatureDisplayNameFromMap(featureDisplayByKey, catalogKey, locale = 'en') {
  const names = featureDisplayByKey?.[catalogKey];
  if (!names || typeof names !== 'object') return null;
  const loc = normalizeFeatureLocale(locale);
  return (names[loc] || names.en || names.de || '').trim() || null;
}

export function getFeatureDisplayNameOrFallback(store, catalogKey, fallback, locale = 'en') {
  return getFeatureDisplayNameFromMap(getFeatureDisplayByKey(store), catalogKey, locale) || fallback;
}

function getCustomerNavigationList(store) {
  const fromGetter = store?.getters?.getCustomerNavigation;
  if (Array.isArray(fromGetter)) return fromGetter;
  return store?.state?.auth?.customerNavigation ?? [];
}

/**
 * Whether a feature is enabled for the customer app (Features Manager `enabled`, roles, env gates).
 * Uses merged `customerNavigation` from login when available; otherwise falls back for legacy drawer.
 */
export function isFeatureEnabledForCustomer(store, catalogKey) {
  const nav = getCustomerNavigationList(store);
  if (nav.length > 0) {
    return nav.some(
      (item) => item.catalogKey === catalogKey && item.itemKind === 'link',
    );
  }
  return Boolean(getFeatureDisplayByKey(store)[catalogKey]);
}

export function getCatalogKeyForRoute(path, features) {
  return resolveCatalogKeyForRoute(path, features);
}

export function getFeatureDisplayNameForRoute(store, path, locale = 'en', features) {
  const catalogKey = getCatalogKeyForRoute(path, features);
  if (!catalogKey) return null;
  return getFeatureDisplayNameOrFallback(store, catalogKey, null, locale);
}

export { isLayoutRowGroup } from '@/utils/navigationCatalog';
